<template>
  <el-dialog
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="1100px"
    custom-class="set-middle-dialog"
  >
    <iframe :src="flowSrc" frameborder="0" class="w-full h-full"></iframe>
  </el-dialog>
</template>

<script>
import { PlanApi } from '@wiz-api/emergency-management'

const planApi = new PlanApi()
export default {
  name: 'ApprovalFlow',
  props: {
    visible: {
      type: Boolean,
      default: false,
    }, // 弹窗显隐
    flowid: {
      type: [String, Number],
      default: '',
    },
    groupid: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    dialogTitle() {
      return this.$t('查看流程')
    }, // dialog标题
  },
  data() {
    return {
      flowSrc: '', // 嵌入流程图的地址
    }
  },
  methods: {
    /**
     * @description 获取iframe嵌入地址的token和ip地址
     */
    async getProcessDetail() {
      const [err, res] = await planApi.getProcess()
      if (!err) {
        this.flowSrc = `${res.apiUrl}/index.html?loadurl=${encodeURIComponent(
          `/flow/run/process?flowid=${this.flowid}&groupid=${this.groupid}&status=-1`
        )}&nroadflow-token=${res.token}&isiframe=1`
      }
    },
  },
  created() {
    this.getProcessDetail()
  },
}
</script>

<style lang="scss">
.set-middle-dialog {
  .el-dialog__body {
    height: 400px !important;
  }
}
</style>
